// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k0-1";
export var messageSideRight = "_k0-2";
export var subscribeToBackInStockBubbleContainer = "_k0-0";